import React, { useEffect, useState } from "react";
import { atom } from "jotai";
import { useQuery } from "@apollo/client";
import { DATE_RANGE_QUERY } from "../../graphql/queries/publicationQuery";
import { Publication } from "./types/publicationDataType";

const NUMBER_OF_DAYS_IN_WEEK = 7;

/**
 *  Atom that can be used to globally get the correct publication info
 */
export const correctPublicationsAtom = atom<Publication[]>([]);
export const projectTitleAtom = atom<string>("");

export const useDateRange = (publicationId: number) => {
	const [range, setRange] = useState({
		today: new Date().getTime(),
		previousWeek: new Date().getTime()
	});
	const [loaded, setLoaded] = useState(false);
	const { data, loading, error } = useQuery(DATE_RANGE_QUERY, {
		context: {
			uri: `https://api.analytics-dev.imfeature.com/graphql?publicationId=${publicationId}`
		},
		variables: {
			params: {
				publicationId: publicationId
			}
		}
	});

	useEffect(() => {
		if (!loading && !error) {
			// eslint-disable-next-line no-magic-numbers
			const timeFrame = data.Deprecated.getTimeFrame[0].timeFrame;
			setRange({ today: timeFrame.end, previousWeek: timeFrame.begin });
			setLoaded(true);
		}
	}, [loading]);

	return { today: range.today, previousWeek: range.previousWeek, loaded };
};

export const setPublicationsCorrect = (
	publicationsRaw: Publication[],
	setCorrectPublications: any,
	setLoaded: any) => {
	const array: Publication[] = [];
	publicationsRaw.forEach(publication => {
		const data = publication.data;
		const session = data.Publication.Sessions;
		const visitors = data.Publication.Visitors;
		const visitorsOverTime = data.Publication.VisitorsOverTime.map((v: any) => {
			return { visitorCount: v.visitorCount, timestamp: v.timestamp, timeUnit: v.timeUnit };
		});

		while (visitorsOverTime.length > NUMBER_OF_DAYS_IN_WEEK)
			visitorsOverTime.shift();

		publication.data = {
			uniqueVisitors: visitors.newVisitorCount,
			averageSessionDuration: session.avgSessionDuration,
			averagePageViewPerSession: session.avgPageviewsPerSessionCount,
			docVisits: session.sessionCount,
			totalVisitors: visitorsOverTime,
		};

		array.push(publication);
	});

	// array.forEach(pub => printPublication(pub));
	setCorrectPublications((previousArray: Publication[]) => [...previousArray, ...array]);
	setLoaded(true);
};

const printPublication = (publication: Publication) => {
	console.log({
		id: publication.id,
		name: publication.name,
		data: publication.data
	});
};
